import { render, staticRenderFns } from "./KeywordResultsSection.vue?vue&type=template&id=6922ba70&"
import script from "./KeywordResultsSection.js?vue&type=script&lang=js&"
export * from "./KeywordResultsSection.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports